import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Design graphique',
    description: 'Création de visuels et supports de communication adaptés à chaque identité.',
    bg: 'bg-[#F4EBE0]',
    icon: 'ri-brush-line',
  },
  {
    title: 'Design visuel',
    description: 'Développement d\'identités visuelles cohérentes, durables et reconnaissables.',
    bg: 'bg-[#E4F0E8]',
    icon: 'ri-palette-line',
  },
  {
    title: 'Conception créative',
    description: 'Création de concepts sur mesure, adaptés aux besoins et objectifs de chaque client.',
    bg: 'bg-[#EDEDED]',
    icon: 'ri-lightbulb-line',
  },
];

export default function ServicesSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = el.querySelectorAll('.service-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.classList.add('animate-fade-up');
                card.classList.remove('opacity-0-init');
              }, i * 120);
            });
            observer.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 md:py-28 px-6 md:px-10 max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 md:mb-16 gap-4">
        <div>
          <span className="text-xs font-medium tracking-[0.3em] text-stone-400 uppercase">Ce que nous proposons</span>
          <h2 className="text-4xl md:text-5xl font-bold text-stone-900 mt-2">Services</h2>
        </div>
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors duration-150 cursor-pointer whitespace-nowrap"
        >
          Discuter d&apos;un projet
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
        </Link>
      </div>

      {/* Cards grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {services.map((service) => (
          <article
            key={service.title}
            className={`service-card opacity-0-init ${service.bg} rounded-2xl p-8 md:p-10 flex flex-col justify-between min-h-[280px] md:min-h-[320px] relative group cursor-default`}
          >
            <div>
              <div className="w-11 h-11 flex items-center justify-center bg-white/70 rounded-xl mb-6">
                <i className={`${service.icon} text-xl text-stone-700`} />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-stone-900 mb-3">{service.title}</h3>
              <p className="text-sm text-stone-600 leading-relaxed">{service.description}</p>
            </div>
            <div className="mt-8 flex items-center justify-between">
              <span className="text-xs font-medium text-stone-400 tracking-wider uppercase">Design · Bordeaux</span>
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/80 group-hover:bg-white transition-colors duration-200">
                <i className="ri-arrow-right-up-line text-sm text-stone-700" />
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}